import * as React from 'react';
import Table from '@mui/material/Table';
import { styled } from '@mui/material/styles';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { observer } from 'mobx-react-lite';
import SkeltonAnimation from '../../../../app/layout/SkeltonAnimation';
import { format } from 'date-fns';
import {
    Box, Card, CardActions, CardContent, CardHeader, Collapse, FormControlLabel, Grid,
    IconButton, IconButtonProps, Skeleton, Stack, Switch, Tooltip, Typography, useMediaQuery
} from '@mui/material';
import { useStore } from '../../../../app/stores/store';
import { FullCustomerCollection } from '../../../../app/models/customer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import { useState } from 'react';
import { withNavbar } from '../../../../app/layout/HOC';
import CollectionReportCard from '../../../basicUser/reports/CollectionReportCard';
import { koReportingContainerStyles } from '../../../basicUser/koreporting/reports/koReportingContainerStyles';
import { mainStyles } from '../../../mainStyles';
import LaodingBoxComponent from '../../../../app/layout/LaodingBoxComponent';
import DescriptionIcon from '@mui/icons-material/Description';
import { city, companyName, koNumber, country, createDate, cgiRef } from '../../../../app/common/options/collectionOpt';
import DeleteCollectionConfirm from './Modals/DeleteCollectionConfirm';
import CollectionReportSearchForm from '../../../basicUser/reports/forms/CollectionReportSearchForm';
import { router } from '../../../../app/router/Routes';
import { useEffectOnce } from 'usehooks-ts';
import PaginationControlled from '../../../../app/common/pagination/PaginationControlled';
import { PagingParams } from '../../../../app/models/pagination';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#fcfcfc',
        fontSize: 16,
        fontWeight: 300,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontWeight: 300,
        fontStrethed: 'expanded',
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({

    '&:nth-of-type(odd)': {
        backgroundColor: '#DAE5F1',
    },
    '&:nth-of-type(even)': {
        backgroundColor: '#fcfcfc',
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


const gridContainer = {
    xs: 1,
    sm: 2,
    md: 3
} as const;

const textGen = (title: string, value: string, xs: number, sm: number) => {
    return <Grid item xs={xs} sm={sm} key={title}>
        <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
        >
            {title}&nbsp;{value || "---"}
        </Stack>
    </Grid>
}
const iconGen = (title: string, value: boolean, xs: number, sm: number) => {
    return <Grid item xs={xs} sm={sm} key={title}>
        <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
        >
            {title}&nbsp;
            {value === false ? <CloseIcon /> : <DoneIcon />}
        </Stack>
    </Grid>
}

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const AdminCollectionReport = () => {
    const [toggle, setToggle] = useState(false);
    const [reportId, setreportId] = useState<string | null>(null);

    const matches = useMediaQuery('(min-width:900px)');

    const { adminCollectionStore: { sortcustomerCollection,  loadingAdminCollections,
        adminCollections,  loadAdminCollectionPagedReports,
        addKoNumberToCollection, idsMarkReadCollectionRead, markReadCollectionRead, createCrfForm,
        deleteCustomerCollection,
        ccPagination, ccPage,
        ccSetPage, setCcPagingParams,
        setCcSearchPredicate, ccSearchFormValues
    },
        modalStore: { openModal, closeModal }
    } = useStore();

    useEffectOnce(() => {
        if (adminCollections.length < 1)
            loadAdminCollectionPagedReports();
    });

  
    const handleReportIdCollapse = (pNo: string) => {
        if (reportId === pNo) {
            setreportId(null);
        } else {
            setreportId(pNo);
        }
    };

    const koUpdateHandler = (id: string, koNumber: string) => {
        if (id) {
            addKoNumberToCollection(id, koNumber);
        }
    }

    const onDeleteCollection = (id: string) => {
        if (id) {
            deleteCustomerCollection(id)
                .finally(() => {
                    closeModal();
                })
                ;
        }
    }


    if (loadingAdminCollections) return loadingAdminCollections &&
        <Box component='div' sx={{ mt: 12 }}>
            {loadingAdminCollections && <SkeltonAnimation iteration={10} />}
        </Box>

    const handleCcPageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        ccSetPage(value);
        setCcPagingParams(new PagingParams(ccPagination!.currentPage = value));
        loadAdminCollectionPagedReports();
    };

    const toggleChangeHandler = (v: boolean) => {
        setToggle(v);
    }

    return (
        <Box component='div' sx={{ mt: 12 }}>
            {!loadingAdminCollections && adminCollections.length < 1 &&
                <Typography variant='h4' textAlign='center' sx={{ mt: 12, color: '#072B02' }} >No records found</Typography>
            }
            {/* Desktop View */}
            {adminCollections.length > 0 && matches &&
                <Stack direction='column' spacing={2}>
                    {toggle ?
                        <CollectionReportSearchForm
                            toggleChangeHandler={toggleChangeHandler}
                            loading={loadingAdminCollections}
                            setCcSearchPredicate={setCcSearchPredicate}
                            getCustomerCollectionPagedList={loadAdminCollectionPagedReports}
                            ccSearchFormValues={ccSearchFormValues} />
                        :
                        <FormControlLabel
                            control={<Switch checked={toggle} color="primary" onChange={() => toggleChangeHandler(true)} name='showCcFilterForm' />}
                            label="Filter"
                            labelPlacement="end"
                        />
                    }
                    <TableContainer component={Paper} sx={koReportingContainerStyles.table}>
                        <Table sx={{ minWidth: 800 }} aria-label="simple table">
                            <TableHead>
                                <TableRow sx={{ bgcolor: '#234f1e' }}>
                                    <StyledTableCell sx={{ cursor: 'pointer' }} onClick={() =>
                                        sortcustomerCollection(koNumber)}>KoNumber</StyledTableCell>
                                    <StyledTableCell sx={{ cursor: 'pointer' }} onClick={() =>
                                        sortcustomerCollection(cgiRef)}>Ref.Nr</StyledTableCell>
                                    <StyledTableCell>CRF</StyledTableCell>
                                    <StyledTableCell sx={{ cursor: 'pointer' }} onClick={() =>
                                        sortcustomerCollection(companyName)}>Company name</StyledTableCell>
                                    <StyledTableCell sx={{ cursor: 'pointer' }} onClick={() =>
                                        sortcustomerCollection(city)}>City</StyledTableCell>
                                    <StyledTableCell sx={{ cursor: 'pointer' }} onClick={() =>
                                        sortcustomerCollection(country)}>Country</StyledTableCell>
                                    <StyledTableCell sx={{ cursor: 'pointer' }} onClick={() =>
                                        sortcustomerCollection(createDate)}>Created date</StyledTableCell>
                                    <StyledTableCell>CollectionDate</StyledTableCell>
                                    <StyledTableCell align="center">Received</StyledTableCell>
                                    <StyledTableCell align="center">PreScanned</StyledTableCell>
                                    <StyledTableCell align="center">Ready to Collect</StyledTableCell>
                                    <StyledTableCell align="right">Action</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {adminCollections.map((report: FullCustomerCollection, index) => {
                                    return (<StyledTableRow
                                        key={index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        {idsMarkReadCollectionRead.some(x => x === report.id)
                                            ? <TableCell colSpan={10}><Skeleton animation="pulse" variant="text" sx={{ fontSize: '1.6rem' }} /></TableCell>
                                            : <>
                                                <StyledTableCell>
                                                    {report.koNumber || 'Waiting11'}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {report.cgiRefNumber || '--'}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {report.koNumber &&
                                                        <Tooltip title="Create CRF form" placement="right">
                                                            <IconButton size='small' onClick={() => createCrfForm(report.id, report.koNumber)}>
                                                                <DescriptionIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    }
                                                </StyledTableCell>

                                                <StyledTableCell>
                                                    {report.contactInfo.companyName}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {report.contactInfo.city}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    {report.contactInfo.country}
                                                </StyledTableCell>
                                                <StyledTableCell sx={{ cursor: 'pointer' }} component="th" scope="row">
                                                    {format(new Date(report.createdAt), 'dd MMM yyyy')}
                                                </StyledTableCell>
                                                <StyledTableCell> {report.isDone ? format(new Date(report.collectionDate!), 'dd-MM-yyyy') : '---'}</StyledTableCell>
                                                <StyledTableCell align="center">{report.isGoodReceived || "--"}</StyledTableCell>
                                                <StyledTableCell align="center">{report.isPreScanDone ? <DoneIcon /> : <CloseIcon />}</StyledTableCell>
                                                <StyledTableCell align="center">{report.koNumber ?
                                                    report.isReadyToCollect ? <DoneIcon /> : <CloseIcon />
                                                    : "--"}
                                                </StyledTableCell>
                                                <StyledTableCell align='right'>
                                                    {report.isUpdated &&
                                                        <Tooltip title="Mark as read" placement="right">
                                                            <IconButton size='small' onClick={() => markReadCollectionRead(report.id)}>
                                                                <TipsAndUpdatesIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    }
                                                    <Tooltip title="See Detail" placement="right">
                                                        <IconButton size='small' onClick={() => router.navigate(`/collectionstatus/${report.id}`)}>
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete" placement="right">
                                                        <IconButton size='small' onClick={() =>
                                                            openModal(<DeleteCollectionConfirm
                                                                collectionId={report.id}
                                                                collectionName={report.koNumber || report.cgiRefNumber || report.contactInfo.companyName}
                                                                onCancel={closeModal}
                                                                onDelete={onDeleteCollection} />)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </StyledTableCell>

                                            </>}
                                    </StyledTableRow>)
                                })}
                            </TableBody>
                        </Table>
                        <Box sx={{ my: 2 }}>
                            <PaginationControlled loading={loadingAdminCollections} count={ccPagination!.totalPages} page={ccPage} handleChange={handleCcPageChange} />
                        </Box>
                    </TableContainer>
                </Stack>
            }
            {/* Mobile View */}
            {!matches &&
                <Box sx={{ flexGrow: 1, mb: 2 }} >
                    <Grid container spacing={2} direction="column" justifyContent="center"
                        alignItems="center">
                        {adminCollections.map((report: FullCustomerCollection, index) => {
                            return (
                                <Grid item xs={12} key={report.id}
                                    sx={{
                                        position: 'relative', pb: 0.5, pr: 0.5, mt: 2,
                                        bgcolor: '#000',
                                        borderRadius: '100% 0% 29% 71% / 0% 100% 0% 100% '
                                    }} >
                                    <Typography component='span' variant='body2'
                                        sx={{ position: 'absolute', right: 6, top: 0.1, color: '#fff' }}>
                                        Tier1Asset
                                    </Typography>
                                    {idsMarkReadCollectionRead.some(x => x === report.id)
                                        ? <Card sx={mainStyles.cardStyles}><LaodingBoxComponent message='updating...' /></Card>
                                        : <Card sx={mainStyles.cardStyles}>
                                            <CardHeader
                                                title={report.koNumber || 'Waiting'}                                      
                                                subheader={report.contactInfo.companyName}
                                            />
                                            <CardContent>
                                                <Grid container direction='row' wrap='wrap' rowSpacing={1} columnSpacing={gridContainer}>
                                                    {textGen('Ref. Nr.', report.cgiRefNumber, 12, 6)}
                                                    {textGen('City', report.contactInfo.city, 12, 6)}
                                                    {textGen('Country', report.contactInfo.country, 12, 6)}
                                                </Grid>
                                            </CardContent>
                                            <CardActions disableSpacing>
                                                {report.isUpdated &&
                                                    <IconButton size='small' onClick={() => markReadCollectionRead(report.id)}>
                                                        <TipsAndUpdatesIcon />
                                                    </IconButton>
                                                }
                                                <IconButton size='small' onClick={() => router.navigate(`/collectionstatus/${report.id}`)}>
                                                    <VisibilityIcon />
                                                </IconButton>
                                                <IconButton size='small' onClick={() =>
                                                    openModal(<DeleteCollectionConfirm
                                                        collectionId={report.id}
                                                        collectionName={report.koNumber || report.cgiRefNumber || report.contactInfo.companyName}
                                                        onCancel={closeModal}
                                                        onDelete={onDeleteCollection} />)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                                <ExpandMore
                                                    expand={reportId === report.id}
                                                    onClick={() => handleReportIdCollapse(report.id)}
                                                    aria-expanded={reportId === report.id}
                                                    aria-label="More info"
                                                >
                                                    <ExpandMoreIcon />
                                                </ExpandMore>
                                            </CardActions>
                                            <Collapse in={reportId === report.id} timeout="auto" unmountOnExit>
                                                <CardContent>
                                                    <Grid container direction='row' wrap='wrap' rowSpacing={1} columnSpacing={gridContainer}>
                                                        {textGen('Created Date:', format(new Date(report.createdAt), 'dd MMM yyyy')
                                                            , 12, 6)}
                                                        {textGen('Recieved', report.isGoodReceived, 12, 6)}
                                                        {textGen('Collection Date:', format(new Date(report.collectionDate!), 'dd MMM yyyy')
                                                            , 12, 6)}
                                                        {iconGen('PreScanned', report.isPreScanDone, 12, 6)}
                                                        {iconGen('Ready to Collect', report.isReadyToCollect, 12, 6)}
                                                        {/* {textGen('Notification', `${getUserRole() === basic
                                                            ? report.customerUnReadCommentCount : report.t1aUnReadCommentCount}`, 12, 6)} */}
                                                    </Grid>
                                                </CardContent>
                                            </Collapse>
                                        </Card>
                                    }
                                </Grid>
                            )
                        })}
                    </Grid>
                </Box>
            }
        </Box>
    );
}

const AdminCollectionReportPage = withNavbar(observer(AdminCollectionReport));

export default AdminCollectionReportPage;


